module.exports = __webpack_public_path__ + "static/media/basic-statistic.0e9d6ef9.png";